import "../assets/style/misc/App.scss";

const LegalRow = ({title, content}) => {
    return(
        <div className="d-md-flex">
            {title != null && (<p className="bold">{title} :</p>)}
            <p className="section-text">{content}</p>
        </div>
    )
}

const Legals = () => {
    return (
        <div className="page-container">
            <div className="section">
                <h1 className="section-title">Mentions légales</h1>
                <p className="section-subtitle">Conformément aux dispositions des articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique (LCEN), il est précisé aux utilisateurs du site <a className="link" href="https://havredepriya.fr/">havredepriya.fr</a> l’identité des différents intervenants dans le cadre de sa réalisation et de son suivi.</p>
            </div>
            <div className="section">
                <h2 className="section-title">1. Éditeur du site</h2>
                <LegalRow title={"Nom de l’entreprise"} content={"SCEA Havre de Priya"}/>
                <LegalRow title={"Forme juridique"} content={"Société Civile d'Exploitation Agricole (SCEA)"}/>
                <LegalRow title={"SIREN"} content={"944 936 087"}/>
                <LegalRow title={"Adresse"} content={"8 rue du moulin, 90110 Félon, France"}/>
                <LegalRow title={"Email"} content={<a className="link" href="mailto:contact@havredepriya.fr">contact@havredepriya.fr</a>}/>
                <LegalRow title={"Directeur de la publication"} content={"Elodie Lutzing"}/>
            </div>
            <div className="section">
                <h2 className="section-title">2. Hébergement</h2>
                <LegalRow title={"Hébergeur"} content={"o2switch"}/>
                <LegalRow title={"Adresse"} content={"222-224 Boulevard Gustave Flaubert, 63000 Clermont-Ferrand, France"}/>
                <LegalRow title={"Téléphone"} content={"04 44 44 60 40"}/>
                <LegalRow title={"Site web"} content={<a className="link" href="https://www.o2switch.fr">https://www.o2switch.fr</a>}/>
                <LegalRow title={"Webmaster"} content={"Site réalisé par Théau Zatti"}/>
                <LegalRow title={"Contact"} content={<a className="link" href="mailto:contact@havredepriya.fr">contact@havredepriya.fr</a>}/>
            </div>
            <div className="section">
                <h2 className="section-title">3. Description des services fournis</h2>
                <LegalRow title={null} content={<>Le site <a className="link" href="https://havredepriya.fr/">havredepriya.fr</a> a pour objet de fournir des informations sur les activités de la société SCEA Havre de Priya.</>}/>
            </div>
            <div className="section">
                <h2 className="section-title">4. Propriété intellectuelle</h2>
                <LegalRow title={null} content={"Le contenu du site (textes, images, graphismes, logo, etc.) est la propriété de la SCEA Havre de Priya, sauf mention contraire."}/>
                <LegalRow title={null} content={"Toute reproduction, distribution, modification, adaptation ou publication est interdite sans l’accord exprès par écrit du propriétaire du site."}/>
            </div>
            <div className="section">
                <h2 className="section-title">5. Limitations de responsabilité</h2>
                <LegalRow title={null} content={"Le site peut contenir des liens vers d’autres sites. La SCEA Havre de Priya ne peut être tenue responsable du contenu de ces sites."}/>
                <LegalRow title={null} content={"Les informations proposées sont données à titre indicatif. La SCEA Havre de Priya ne pourra être tenue responsable des omissions ou des erreurs."}/>
            </div>
            <div className="section">
                <h2 className="section-title">6. Données personnelles</h2>
                <LegalRow title={null} content={"Le site ne collecte pas de données personnelles à des fins commerciales."}/>
                <LegalRow title={null} content={"Un formulaire de contact est disponible à titre informatif ; les informations saisies (nom, email, message) ne sont pas conservées ni utilisées à des fins de prospection."}/>
                <LegalRow title={null} content={"Aucune donnée n’est transmise à des tiers."}/>
            </div>
            <div className="section">
                <h2 className="section-title">7. Cookies</h2>
                <LegalRow
                    title={null}
                    content={<>Le site <a className="link" href="https://havredepriya.fr/">havredepriya.fr</a> peut utiliser des cookies ou outils de suivi à des fins statistiques, sans collecte de données personnelles.</>}
                />
            </div>
            <div className="section">
                <h2 className="section-title">8. Droit applicable</h2>
                <LegalRow title={null} content={<>Tout litige en relation avec l’utilisation du site <a className="link" href="https://havredepriya.fr/">havredepriya.fr</a> est soumis au droit français. En cas de litige, les tribunaux français seront seuls compétents.</>}/>
            </div>
        </div>
    );
}

export default Legals;